module.exports = __webpack_public_path__ + "img/alert.e243deb1.svg";